const n = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fill-rule="evenodd"
        d="M7.152 2.123A10.955 10.955 0 0 1 12 1c1.74 0 3.385.404 4.848 1.123A17.669 17.669 0 0 0 12 4.337a17.667 17.667 0 0 0-4.848-2.214ZM2.937 18.235A10.949 10.949 0 0 1 1 12a10.97 10.97 0 0 1 3.56-8.103C5.948 4.351 7.566 5.3 9.224 6.58c-2.922 2.866-5.076 6.828-6.287 11.656Zm16.559 1.816A10.961 10.961 0 0 1 12 23c-2.896 0-5.531-1.12-7.496-2.95 1.2-3.74 4.212-7.87 7.496-11.056 3.284 3.187 6.296 7.317 7.496 11.057Zm1.567-1.816A10.95 10.95 0 0 0 23 12a10.97 10.97 0 0 0-3.56-8.103c-1.387.454-3.006 1.403-4.664 2.681 2.922 2.867 5.075 6.83 6.287 11.657Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  n as default
};
